import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { RedirectionLandingService } from '@src/app/core/services/ib-subscription-models-redirection-service';
import { subscriptionModelsAppConstant } from '@src/ib-subscription-models-app-constants';
import { CommonsSessionStorageService, downgradeToAJSComponent } from 'ib-web-commons/utils';
import { IbSubscriptionModelsPaymentsService } from './service/payments/ib-subscription-models-payments.service';
import { IbSubscriptionModelsPaymentWebComponentService } from './service/payments-web-component/ib-subscription-models-payments-web-component.service';
import { ReactComponentData } from '@src/app/core/models/generic-models';
import { initSubscriptionModelsServiceModel } from '@src/app/core/models/summary-service.model';
import { Summary, SummaryProps } from 'commercial-management--ancillaries--web-components-design--library';
import { ReplaySubject, Subject, takeUntil } from 'rxjs';
import { GetContextResponse, PmtRedirectionInfo } from '../../../core/models/ib-subscription-models-payment-model';


@Component({
    selector: 'ib-subscription-models-payments',
    templateUrl: './ib-subscription-models-payments.component.html',
    styleUrls: ['./ib-subscription-models-payments.component.scss']
})
export class IbSubscriptionModelsPaymentsComponent implements OnInit, OnDestroy {

    public contextId:string;
    private paymentComponent: any;
    private pmtPaymentUpdateStm = new ReplaySubject(1);
    // Subject to force unsuscribe in order to avoid memory leaks
    private unsuscribeUpdatesStm = new Subject<void>();
    private pmtContext: GetContextResponse = {contextId: null, warnings: null};



    public summaryComponent: ReactComponentData<SummaryProps> = {
        component: Summary,
        props: {} as SummaryProps
    };

    constructor (
        @Inject('CommonsModalService') private commonsModalService: CommonsModalService,
        @Inject('RedirectionLandingService') private redirectionLandingService: RedirectionLandingService,
        private commonsSessionStorageService: CommonsSessionStorageService,
        private ibSubscriptionModelsPaymentsService: IbSubscriptionModelsPaymentsService,
        private ibSubscriptionModelsPaymentWebComponentService: IbSubscriptionModelsPaymentWebComponentService

    ) {}

    ngOnDestroy (): void {
        this.unsuscribeUpdatesStm.next();
        this.unsuscribeUpdatesStm.complete();
    }

    async ngOnInit (): Promise<void> {
        this.showWaitingModal();
        this.commonsSessionStorageService.set('actualStepFlow', 'ibpurc');
        this.commonsSessionStorageService.set(subscriptionModelsAppConstant.SESSION_STORAGE.IS_NEW_PAYMENT, true);

        try {
            const response: initSubscriptionModelsServiceModel = await this.ibSubscriptionModelsPaymentsService.initPaymentForm();
            const pmtRedirectContext: PmtRedirectionInfo = this.commonsSessionStorageService.get('pmtRedirectContext');
            const contextId: string = pmtRedirectContext ? pmtRedirectContext.contextResponse.contextId : response.paymentContext;
            this.pmtContext.contextId =  contextId;

            this.paymentComponent = await this.ibSubscriptionModelsPaymentWebComponentService.getNewPaymentComponent({
                contextId: this.pmtContext.contextId,
                onPaymentFailure: this.paymentFailure,
                onPaymentSuccess: this.paymentOk,
                target: document.querySelector('#pmt-container'),
                auth:{token:this.commonsSessionStorageService.get('anonymousToken')}
            }).then((PaymentWebComponent) => {
                PaymentWebComponent.subscribe('payment', (paymentUpdate) => {this.pmtPaymentUpdateStm.next(paymentUpdate);});
            });

            this.commonsSessionStorageService.remove('pmtRedirectContext');
            this.initPaymentSubjects();
            this.summaryComponent.props = response.summaryProps;
            this.closeWaitingModal();

        } catch (error) {
            this.closeWaitingModal();
            this.commonsModalService.showGenericError(error, true, null).result.then(() => {
                this.redirectionLandingService.redirection(subscriptionModelsAppConstant.market.toLowerCase(), subscriptionModelsAppConstant.lang.toUpperCase());
            });
        }
    }

    private initPaymentSubjects (): void {
        this.pmtPaymentUpdateStm.pipe( takeUntil( this.unsuscribeUpdatesStm ) ).subscribe( ( data ) => {this.checkPaymentUpdate(data);} );

    }

    private checkPaymentUpdate = (data) => {
        const {status} = data;
        // this.toggleLoadingOverlay(true, 'PAY');

        if('REDIRECTION' === status) {
            this.ibSubscriptionModelsPaymentsService.redirectedPaymentTypeAction( this.pmtContext );
        } else if('ERROR'=== status){
            // this.toggleLoadingOverlay(false);
        }
    };

    private paymentOk (): void {
        window.location.hash = '#!' + subscriptionModelsAppConstant.PAGES_ROUTES.CONFIRMATION;
    }

    private paymentFailure (): void {
        window.location.href = window.location.origin;
    }

    private showWaitingModal (): void {
        this.commonsModalService.showWaitingModal('ib-modal-loading-plane', 'ib-modals ib-modals--transparent ib-modals--loading-page', true, null);
    }

    private closeWaitingModal () {
        this.commonsModalService.finishWaiting();
        this.commonsModalService.closeAllCurrentModals();
    }

}

downgradeToAJSComponent('ibSubscriptionModelsPayments', {
    component: IbSubscriptionModelsPaymentsComponent,
    inputs: []
}, 'ib-subscription-models-payments');
